import WithPermission from 'Components/SharedComponents/WithPermission/WithPermission'
import { lazy } from 'react'
import FunderGoals from './FunderGoals/FunderGoals'

import FunderTeamPage from '../FunderTeam/FunderTeamPage/FunderTeamPage'

import { FunderGoal } from './FunderGoals/FunderGoal/FunderGoal'

const FunderDashboardContainer = lazy(
  () => import('./FunderDashboardContainer/FunderDashboardContainer')
)
const FunderDashboardPage = lazy(
  () => import('./FunderDashboardPage/FunderDashboardPage')
)

const FunderGranteePage = lazy(
  () => import('./FunderGranteePage/FunderGranteePage')
)

const FunderOrgStoriesPage = lazy(
  () => import('../FunderOrgStories/FunderOrgStoriesPage')
)

const PublishedImpactStory = lazy(
  () =>
    import(
      'Components/Pages/Impact/ImpactStories/PublishedImpactStory/PublishedImpactStory'
    )
)

const EngagementDashbaord = lazy(() => import('./OmniDashboard/OmniDashboard'))

const ImpactDashboard = lazy(
  () => import('./FunderImpactDashboard/FunderImpactDashboardPage')
)

export default {
  path: '/funder',
  exact: false,
  Component: WithPermission(
    FunderDashboardContainer,
    ['page:funder_dashboard'],
    false
  ),
  access: 'USER',
  routes: [
    {
      path: `/funder/dashboard`,
      exact: true,
      Component: FunderDashboardPage,
      access: 'USER',
    },
    {
      path: `/funder/dashboard/engagement`,
      exact: true,
      Component: EngagementDashbaord,
      access: 'USER',
    },
    {
      path: `/funder/dashboard/impact`,
      exact: true,
      Component: WithPermission(
        ImpactDashboard,
        ['page:funder_dashboard:impact_intelligence'],
        true
      ),
      access: 'USER',
    },
    {
      path: `/funder/grantees`,
      exact: true,
      Component: FunderGranteePage,
      access: 'USER',
    },
    {
      path: `/funder/impact/stories/shared`,
      exact: true,
      Component: FunderOrgStoriesPage,
      access: 'USER',
    },
    {
      path: `/funder/impact/stories/view/:id`,
      exact: true,
      Component: PublishedImpactStory,
      access: 'USER',
    },
    {
      path: `/funder/stories/shared`,
      exact: true,
      Component: FunderOrgStoriesPage,
      access: 'USER',
    },
    {
      path: `/funder/stories/view/:id`,
      exact: true,
      Component: PublishedImpactStory,
      access: 'USER',
    },
    {
      path: '/funder/team',
      exact: true,
      Component: FunderTeamPage,
      access: 'USER',
    },
    {
      path: `/funder/impact/goals`,
      exact: true,
      Component: FunderGoals,
      access: 'USER',
    },
    {
      path: [`/funder/impact/goals/:goalId`],
      exact: true,
      Component: FunderGoal,
      access: 'USER',
    },
    {
      path: [`/funder/impact/goals/group/:goalGroupId`],
      exact: true,
      Component: FunderGoal,
      access: 'USER',
    },
  ],
}
